import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
function pad(value: number) {
  return value.toString().padStart(2, '0');
}
export function useCountdown() {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS);
  useEffect(() => {
    const interval = window.setInterval(() => {
      setRemaining(prev => prev <= 1 ? TOTAL_SECONDS : prev - 1);
    }, 1000);
    return () => window.clearInterval(interval);
  }, []);
  return {
    hours: pad(Math.floor(remaining / 3600)),
    minutes: pad(Math.floor(remaining % 3600 / 60)),
    seconds: pad(remaining % 60)
  };
}
type CountdownTimerProps = {
  label?: string;
  note?: string;
};
export function CountdownTimer({
  label,
  note
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const units: {
    value: string;
    caption: string;
  }[] = [{
    value: hours,
    caption: 'HRS'
  }, {
    value: minutes,
    caption: 'MIN'
  }, {
    value: seconds,
    caption: 'SEC'
  }];
  return <div className="w-full rounded-2xl border border-red-500/40 bg-red-950/40 p-4 text-center sm:p-5" data-id="element-18" data-mp="1c0ongbidbbo3">
      {label ? <p className="font-display text-[15px] font-bold uppercase tracking-[0.12em] text-red-300 sm:text-lg" data-id="element-19" data-mp="1h0b30rlo5402">
          ⏰ {label}
        </p> : null}
      <div className="mt-3 flex items-center justify-center gap-2 sm:gap-3" role="timer" aria-live="off" aria-label={`Offer ends in ${hours} hours ${minutes} minutes ${seconds} seconds`} data-id="element-20" data-mp="124lp7gqmzx6f">
        {units.map((unit, index) => <React.Fragment key={unit.caption} data-id="element-21" data-mp="1zoy654kabjb0" data-mpi={index}>
            {index > 0 ? <span className="font-display text-2xl font-bold text-red-400/70 sm:text-3xl" data-id="element-22" data-mp="1l24z0mkx5jtw">
                :
              </span> : null}
            <div className="min-w-[64px] rounded-xl bg-navy-950 px-2 py-2 shadow-inner sm:min-w-[84px] sm:px-3 sm:py-3" data-id="element-23" data-mp="1pyd7jh4m2es3">
              <div className="font-display text-[34px] font-extrabold leading-none tabular-nums text-white sm:text-5xl" data-id="element-24" data-mp="2igqycwrj50ho">
                {unit.value}
              </div>
              <div className="mt-1 text-[10px] font-bold tracking-[0.18em] text-red-300 sm:text-xs" data-id="element-25" data-mp="2sby3ite9kbc2">
                {unit.caption}
              </div>
            </div>
          </React.Fragment>)}
      </div>
      {note ? <p className="mt-3 text-[12px] font-medium text-white/70 sm:text-sm" data-id="element-26" data-mp="2ed88djb08lqc">
          {note}
        </p> : null}
    </div>;
}